import React from "react";
import {BotonAperturar} from "../Plantillas/Botones";
import Notify from "../Notify";
import _ from "lodash";
import {notificarError} from "../Almacenes/AlmacenNotify";

export default class TurnoApertura extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            cajas: [],
            dataC: {Cajas: []},
            IdCaja: 0,
            GuardarEnAperturarCaja: false,
            ObservacionApertura: '',
            MontoInicial: 0,
            Observacion: '',
            isLoading: false
        }
        this.handleChange = this.handleChange.bind(this);
        this.montoAperturaVacio = this.montoAperturaVacio.bind(this);
        this.AperturarTurno = this.AperturarTurno.bind(this);
    }

    async componentDidMount() {
        this.setState({isLoading: true})
        await this.obtenerCajas();
        this.setState({isLoading: false})
    }

    async obtenerCajas() {
        try {
            const response = await fetch(`/api/cajas/cajas/SinTurnos`);
            const data = await response.json();
            if (data.Cajas.length !== 0)
                this.setState({
                    dataC: data,
                    IdCaja: data.Cajas[0].IdCaja,
                    GuardarEnAperturarCaja: false
                })
            else
                Notify("Registre una caja", "warning", 1500);
        } catch (error) {
            notificarError("Hubo un error al momento de obtener las cajas.")
        }
    }

    handleChange(e) {
        const {name, value} = e.target
        this.setState({
            [name]: e.target.getAttribute('type') === 'number' ? (_.isNumber(Number(value)) ? value : 0) : value
        })
    }

    montoAperturaVacio(e) {
        if (this.state.MontoInicial === '') {
            this.setState({
                MontoInicial: 0
            })
        }
    }

    async AperturarTurno(e) {
        e.preventDefault();
        try {
            const res = await fetch(`/api/cajas/aperturar/turno`, {
                method: 'POST',
                body: JSON.stringify({
                    IdCaja: this.state.IdCaja,
                    MontoInicial: this.state.MontoInicial,
                    Observacion: this.state.ObservacionApertura
                }),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })
            const rpta = await res.json()
            window.location.reload();
        } catch (err) {
            console.log("err ", err)
            notificarError("Ha ocurrido un error al momento de aperturar turno")
        }
    }

    render() {
        return (
            <React.Fragment>
                <form>
                    <div className="">
                        <div className="mt-4">
                            <b className="ml-2 mt-4 mr-2">Caja: </b>
                            <div className="input__Almacen mr-2 ml-2">
                                <select required className="input__linea mt-2 ml-2 mr-2 col-11" name="IdCaja"
                                        onChange={this.handleChange} value={this.state.IdCaja}>{
                                    this.state.dataC.Cajas.map((obj) => {
                                        return <option key={obj.IdCaja} value={obj.IdCaja}>{obj.Nombre}</option>
                                    })}
                                </select>
                            </div>
                        </div>

                        <div className="">
                            <b className="ml-2 mt-4 mr-2">Monto Apertura: </b>
                            <div className="input__Almacen mr-2 ml-2">
                                <input
                                    name="MontoInicial"
                                    className="input__linea mt-2 ml-2 mr-2 col-11"
                                    type="number" step="any" min="0"
                                    value={this.state.MontoInicial}
                                    onFocus={(e) => e.target.select()}
                                    onChange={this.handleChange}
                                    onBlur={this.montoAperturaVacio}
                                />
                            </div>
                        </div>

                        <div className="almacenDiv">
                            <b className="ml-2 mt-4 mr-2">Observación: </b>
                            <div className="input__Almacen mr-2 ml-2">
                                <input
                                    type="text"
                                    name="ObservacionApertura"
                                    className="input__linea mt-2 ml-2 mr-2 col-11"
                                    value={this.state.ObservacionApertura}
                                    onChange={this.handleChange}
                                />
                            </div>
                        </div>
                        <div align="center" className="mb-2">
                            <BotonAperturar title="Aperturar Caja"
                                            className="ml-4 mt-2"
                                            type="button"
                                            onClick={this.AperturarTurno}/>
                        </div>
                    </div>
                </form>
            </React.Fragment>
        )
    }
}
